var map = {
	"./act": 1507,
	"./act.ts": 1507,
	"./gmat": 1508,
	"./gmat.ts": 1508,
	"./gre": 1509,
	"./gre.ts": 1509,
	"./ielts": 1510,
	"./ielts.ts": 1510,
	"./ielts_general_training": 1511,
	"./ielts_general_training.ts": 1511,
	"./lsat": 1512,
	"./lsat.ts": 1512,
	"./mcat": 1513,
	"./mcat.ts": 1513,
	"./sat": 1514,
	"./sat.ts": 1514,
	"./toefl": 1515,
	"./toefl.ts": 1515
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 2518;
module.exports = webpackAsyncContext;